var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"Logo",attrs:{"src":_vm.icon,"alt":_vm.$t('globals.website'),"width":_vm.width,"height":"88"}})
}
var staticRenderFns = []

export { render, staticRenderFns }